export const companyProfile = {
  brandName: '泰杰儒雅科技',
  legalName: '陕西泰杰儒雅网络科技有限公司',
  city: '西安高新技术产业开发区',
  domain: 'https://tg-release.com',
  icp: '陕ICP备2022011907号-1',
  slogan: '把 AI 能力、业务流程和交付工程真正落到线上结果里',
  description:
    '聚焦 AI 推荐、小程序与 Web 应用、企业数字化平台建设，强调“可上线、可验证、可持续迭代”的实际交付。'
};

export const navItems = [
  { label: '首页', path: '/' },
  { label: '关于我们', path: '/about' },
  { label: '业务服务', path: '/services' },
  { label: '行业方案', path: '/solutions' },
  { label: '客户案例', path: '/cases' },
  { label: '技术优势', path: '/advantages' },
  { label: '常见问题', path: '/faq' },
  { label: 'API Web', path: '/api-web' }
];

export const homeMetrics = [
  { label: '首批交付', value: '诊断清单 + 路线图 + MVP 范围' },
  { label: '实施原则', value: '核心链路优先上线并可验证' },
  { label: '上线门槛', value: '构建通过 + 烟雾测试 + 回滚预案' }
];

export const serviceCards = [
  {
    title: 'AI 增长与推荐系统',
    subtitle: '从推荐策略、埋点闭环到增长实验的一体化建设',
    points: ['推荐策略设计与指标口径定义', '用户画像与召回排序能力建设', 'AB 实验、看板与留存提升闭环']
  },
  {
    title: '小程序 / H5 / 官网项目',
    subtitle: '兼顾品牌展示、转化路径与前后端联调交付',
    points: ['官网、落地页、小程序统一体验设计', '接口联调、异常兜底与发布上线', '咨询入口、表单、转化链路优化']
  },
  {
    title: '企业数字化平台',
    subtitle: '围绕流程在线化、权限治理和数据资产沉淀展开',
    points: ['审批、工单、报表等核心流程重构', '角色权限、审计追踪与看板体系', '监控巡检、持续优化与版本迭代']
  }
];

export const painPoints = [
  '官网只有品牌展示，没有可承接咨询的明确入口',
  '需求经常停留在方案层，缺少首批可交付清单和上线节奏',
  '接口、前端和部署协作分散，导致上线前问题集中爆发',
  '项目上线后缺少持续观察与优化，结果难以沉淀为能力'
];

export const deliveryPackages = [
  {
    title: '业务诊断与方案梳理',
    duration: '2-5 个工作日',
    summary: '适合启动前快速澄清目标、范围与上线路径。',
    deliverables: ['现状问题清单', '业务目标与关键指标拆解', '首期 MVP 范围与里程碑建议', '风险点与资源协同建议']
  },
  {
    title: '核心链路开发与联调',
    duration: '2-6 周',
    summary: '聚焦最影响结果的流程，先交付可运行版本。',
    deliverables: ['页面与交互原型', '关键接口联调清单', '核心场景可运行版本', '联调记录与问题闭环说明']
  },
  {
    title: '上线保障与迭代优化',
    duration: '按月 / 按阶段',
    summary: '把上线验证、巡检和后续优化纳入固定动作。',
    deliverables: ['构建与部署验证', '健康检查与 smoke 测试建议', '监控与告警补齐建议', '下一轮优化 backlog']
  }
];

export const caseHighlights = [
  {
    title: '本地生活推荐系统重构',
    industry: '本地生活 / 增长',
    outcome: '3 周内完成召回与排序策略调整，CTR 提升 31%。',
    details: '交付内容覆盖指标重定义、埋点梳理、实验看板与策略回放，便于后续持续迭代。'
  },
  {
    title: '小程序链路与体验改造',
    industry: '小程序 / 线上转化',
    outcome: '同轮解决接口异常、页面加载与转化流失问题。',
    details: '将咨询入口、关键表单和异常提示一并重做，发布后稳定性与到达率显著提升。'
  },
  {
    title: '企业流程平台上线',
    industry: '企业服务 / 效率',
    outcome: '审批与工单流程闭环后，人均处理时长下降 42%。',
    details: '通过角色权限、流程节点和经营看板重构，补齐上线后的巡检与问题回溯机制。'
  }
];

export const workflowSteps = [
  {
    title: '01 需求诊断',
    description: '围绕业务目标、当前痛点、时间窗口和资源情况快速达成共识。',
    output: '诊断摘要、优先级和首批范围'
  },
  {
    title: '02 路线拆解',
    description: '确认页面、接口、数据和发布依赖，优先保证关键链路可跑通。',
    output: '里程碑、联调清单和风险表'
  },
  {
    title: '03 开发联调',
    description: '按里程碑推进开发、联调、问题修复与版本验收。',
    output: '可运行版本与问题闭环记录'
  },
  {
    title: '04 上线验证',
    description: '执行构建、烟雾测试、健康检查与回滚准备，降低上线不确定性。',
    output: '上线记录、验证结果和后续优化项'
  }
];

export const consultationOptions = {
  projectTypes: [
    '官网改版 / 品牌站',
    '小程序 / H5 项目',
    'AI 推荐 / 增长场景',
    '企业流程 / 管理平台',
    '接口联调 / 上线保障',
    '其他定制需求'
  ],
  stages: ['从 0 到 1 启动中', '已有系统待重构', '核心链路待联调', '即将上线需保障', '上线后持续优化'],
  launchWindows: ['1 周内', '2-4 周', '1-2 个月', '2 个月以上', '时间待评估'],
  budgetRanges: ['3 万以内', '3-10 万', '10-30 万', '30 万以上', '暂未确定']
};

export const detailPages = {
  about: {
    title: '关于我们',
    intro:
      '泰杰儒雅科技聚焦企业数字化与 AI 能力落地，提供从需求分析、技术实现到上线运营的一体化服务。',
    blocks: [
      {
        title: '公司定位',
        content:
          '我们更关心“这次上线能不能跑、能不能验证、后续能不能迭代”，而不是只交一份漂亮方案。'
      },
      {
        title: '合作方式',
        content:
          '从需求诊断、方案拆解、开发联调到部署验证，围绕业务目标推进，重要节点保留明确可验收产出。'
      },
      {
        title: '交付边界',
        content:
          '覆盖品牌站、小程序、AI 推荐、业务系统与上线保障，适合需要真实结果而非纯文档咨询的项目。'
      }
    ],
    ctaTitle: '准备开始一轮需求诊断？',
    ctaDescription: '把目标、时间窗口和现状告诉我们，即可生成首批交付建议。'
  },
  services: {
    title: '业务服务',
    intro: '围绕增长、转化、效率和管理四类目标，提供可拆分、可组合的模块化服务。',
    blocks: [
      {
        title: '增长与转化',
        content: '推荐策略、营销落地页、咨询入口、表单链路、AB 实验与数据看板。'
      },
      {
        title: '产品与系统建设',
        content: '官网、小程序、H5、业务后台、流程平台以及关键接口能力开发与联调。'
      },
      {
        title: '上线与运维协同',
        content: '构建验证、烟雾测试、健康检查、回滚预案与发布后巡检支持。'
      }
    ],
    ctaTitle: '先做哪一部分最合适？',
    ctaDescription: '如果你还不确定优先级，可以先走一轮诊断，再确定首期范围。'
  },
  solutions: {
    title: '行业方案',
    intro: '不是套模板，而是围绕具体业务链路拆解出贴近场景的实施方式。',
    blocks: [
      {
        title: '零售与本地生活',
        content: '重点关注获客、推荐、团购/商品转化以及线下门店协同的闭环。'
      },
      {
        title: '教育与培训',
        content: '关注课程推荐、学习路径、留资转化、运营看板与教研反馈效率。'
      },
      {
        title: '企业服务与管理',
        content: '围绕审批、工单、知识库、数据看板等能力，提升内部协作和决策效率。'
      }
    ],
    ctaTitle: '你的场景适合哪种落地方式？',
    ctaDescription: '在咨询页提交项目背景后，可直接生成与你场景匹配的首批建议。'
  },
  cases: {
    title: '客户案例',
    intro: '案例不是只看页面效果，更要看关键指标、上线节奏和后续迭代机制。',
    blocks: caseHighlights.map((item) => ({
      title: `${item.title} · ${item.industry}`,
      content: `${item.outcome} ${item.details}`
    })),
    ctaTitle: '想看更接近你业务的案例方向？',
    ctaDescription: '填写行业、目标和时间窗口后，可先给出适合参考的实施路径。'
  },
  advantages: {
    title: '技术优势',
    intro: '坚持工程化与可维护性，不用短期堆代码换一个无法接手的上线版本。',
    blocks: [
      {
        title: '结果导向的工程方法',
        content: '优先打通关键链路，把构建、联调、验证作为交付的一部分，而不是最后补。'
      },
      {
        title: '上线前的验证意识',
        content: '重要节点关注构建是否通过、接口是否可调、页面是否能转化，而非只看静态演示。'
      },
      {
        title: '可持续迭代的结构',
        content: '在首期交付时就考虑日志、看板、告警和后续版本规划，避免每次都从零开始。'
      }
    ],
    ctaTitle: '如果你担心“能做出来但接不住”',
    ctaDescription: '可以先用咨询页梳理现状，我们会把实施和上线风险一并纳入首批建议。'
  },
  faq: {
    title: '常见问题',
    intro: '把合作前最常见的几个问题说清楚，方便快速判断是否适合现在启动。',
    blocks: [
      {
        title: '项目周期怎么估？',
        content: '先确认业务目标、最小范围和依赖关系，再按“诊断—联调—上线”拆里程碑，不直接拍脑袋给总工期。'
      },
      {
        title: '如何保证上线稳定？',
        content: '上线前至少会关注构建、关键接口 smoke 测试、页面主链路验证和必要的回滚准备。'
      },
      {
        title: '没有完整需求文档可以开始吗？',
        content: '可以，很多项目都是从诊断清单开始，先把目标、边界和首批交付梳理清楚。'
      }
    ],
    ctaTitle: '还有没覆盖到的问题？',
    ctaDescription: '直接在咨询页补充现状与疑问，我们会一起把边界梳理清楚。'
  }
};
